exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media screen and (min-width: 768px) {\n.logo[data-v-1bebee94] {\n    transition: min-height .5s cubic-bezier(.075, .82, .165, 1) .5s;\n    min-height: 300px;\n&.reveal {\n      transition: min-height .5s ease-in-out;\n      min-height: 200px;\n}\n}\n.data[data-v-1bebee94] {\n    transition: max-height .5s cubic-bezier(.075, .82, .165, 1) .5s;\n    overflow: hidden;\n    max-height: 0;\n&.reveal {\n      max-height: 250px;\n      transition: max-height .5s ease-in-out;\n}\n}\n}\n", ""]);

// exports
